const formatCpf = (val: string): string => (val ? `${val.substring(0, 3)}.${val.substring(3, 6)}.${val.substring(6, 9)}-${val.substring(9, 11)}` : 'não informado');

export default formatCpf;
